import React from 'react';

interface TextAreaProps {
  value: string;
  placeholder: string;

  onChange(v: string): void;
  rows?: number;
}

export const TextArea = ({
  value,
  onChange,
  placeholder,
  rows = 2,
}: TextAreaProps) => {
  return (
    <textarea
      rows={rows}
      className="w-full border border-gray-300 px-3 py-2 rounded focus:outline-none focus:border-black"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};
